<template>
  <div class="terms-wrapper">
    <section id="terms">
      <h2>使用条款</h2>
      <div class="legal-page">
        <h1>网站使用条款</h1>
        <p class="updated-at">最后更新日期：2025 年 1 月 1 日</p>

        <p>
          欢迎访问由
          <strong>登竣实业（上海）有限公司</strong>
          （以下简称"我们"）运营的官方网站。访问或使用本网站，即表示您已阅读、理解并同意遵守本使用条款。
          如您不同意本条款的任何内容，请立即停止使用本网站。
        </p>

        <section>
          <h2>一、网站用途</h2>
          <p>本网站主要用于：</p>
          <ul>
            <li>展示我们的公司信息与业务简介；</li>
            <li>介绍我们的产品与服务相关内容；</li>
            <li>为您提供在线留言与咨询渠道；</li>
            <li>为您提供有关包材等主题的 AI 问答与互动功能。</li>
          </ul>
          <p>您仅可在合法、合理且遵守本条款的前提下使用本网站及相关服务。</p>
        </section>

        <section>
          <h2>二、用户行为规范（留言与 AI 对话）</h2>
          <p>在使用本网站的留言功能或 AI 对话功能时，您承诺：</p>
          <ul>
            <li>遵守中国及您所在地适用的法律法规；</li>
            <li>遵守社会公序良俗，不发布违反伦理道德的内容；</li>
            <li>不发布任何不实、误导性或恶意诽谤的信息；</li>
            <li>不发布侵犯他人知识产权、隐私权或其他合法权益的内容；</li>
            <li>不发布暴力、恐怖、色情、赌博、仇恨、歧视等违法违规内容；</li>
            <li>不发布危害国家安全、社会稳定或含有政治敏感内容的信息；</li>
            <li>不进行任何形式的垃圾信息、广告信息、恶意营销等行为；</li>
            <li>不尝试利用留言或 AI 功能攻击、干扰或破坏网站正常运行。</li>
          </ul>
          <p>
            如我们发现您存在违反上述要求的情形，有权对相关内容进行屏蔽、删除，必要时限制或终止您使用本网站相关功能，并在法律要求或监管机关要求时配合提供相关记录。
          </p>
        </section>

        <section>
          <h2>三、AI 服务条款</h2>
          <p>
            本网站的 AI 助手服务基于包括 DeepSeek API 在内的相关技术实现，旨在为您提供有关包装材料等主题的自动化咨询与参考信息。
          </p>
          <p>您理解并同意：</p>
          <ul>
            <li>AI 回复为算法模型自动生成，可能存在不准确、不完整或过期的情况；</li>
            <li>AI 提供的信息仅供参考，不构成任何形式的法律、财务、医疗或其他专业意见；</li>
            <li>AI 内容不应作为您做出重大决策的唯一依据；</li>
            <li>AI 生成内容不代表登竣实业（上海）有限公司的立场或意见；</li>
            <li>在法律允许的范围内，我们对您因完全依赖 AI 内容所产生的损失不承担责任。</li>
          </ul>
          <p>
            同时，您应避免在与 AI 对话中输入敏感的个人信息，包括但不限于身份证号码、银行账户、医疗信息等。
          </p>
        </section>

        <section>
          <h2>四、知识产权</h2>
          <p>本网站上的所有内容，包括但不限于：</p>
          <ul>
            <li>文字、图片、图标、LOGO、页面设计与版式；</li>
            <li>产品介绍、宣传文案；</li>
            <li>与本网站相关的软件代码和技术实现等；</li>
          </ul>
          <p>
            均受著作权法、商标法及相关知识产权法律保护，由登竣实业（上海）有限公司或相关权利人享有相应权利。
            未经我们事先书面许可，您不得以任何方式复制、修改、传播、转载、出售、镜像或用于商业用途。
          </p>
        </section>

        <section>
          <h2>五、禁止行为</h2>
          <p>在使用本网站及其服务过程中，您不得从事包括但不限于以下行为：</p>
          <ul>
            <li>对本网站进行任何形式的攻击、入侵、扫描或测试其安全性；</li>
            <li>未经授权尝试访问网站的非公开部分或服务器资源；</li>
            <li>以任何自动化方式（如爬虫、脚本）大量抓取网站内容，除非事先获得书面许可；</li>
            <li>试图绕过或破坏网站的安全性措施；</li>
            <li>利用本网站从事任何违法、欺诈或侵害他人权益的行为。</li>
          </ul>
          <p>如您违反上述条款，我们有权在不事先通知的情况下采取包括但不限于：</p>
          <ul>
            <li>限制或终止您对本网站的访问；</li>
            <li>删除您发布的内容；</li>
            <li>向有关主管部门报告等。</li>
          </ul>
        </section>

        <section>
          <h2>六、免责声明</h2>
          <p>在法律允许的范围内，我们就以下事项不承担责任：</p>
          <ul>
            <li>
              因网络故障、设备故障、不可抗力（包括但不限于自然灾害、政府行为等）导致的网站服务中断或不可用；
            </li>
            <li>
              网站内容或 AI 生成内容存在的错误、遗漏或不准确之处，您据此做出的任何决策或行动所产生的损失；
            </li>
            <li>通过本网站的外部链接访问的第三方网站或服务的内容、安全性或合法性；</li>
            <li>因您自身原因导致账号或信息泄露、设备中毒等情况所造成的损失。</li>
          </ul>
        </section>

        <section>
          <h2>七、条款的修改与更新</h2>
          <p>
            我们保留在任何时间根据业务需要或法律法规变更对本使用条款进行修改的权利。
            修订后的条款一经在本页面发布即生效，并替代原有条款。
            如您在条款更新后继续使用本网站，即视为您已接受更新后的条款。
          </p>
        </section>

        <section>
          <h2>八、适用法律与争议解决</h2>
          <p>
            本使用条款的订立、执行与解释，适用中华人民共和国现行法律。
            因使用本网站或本条款引起的任何争议，应首先友好协商解决；协商不成时，任何一方可向我们所在地有管辖权的人民法院提起诉讼。
          </p>
        </section>

        <section>
          <h2>九、联系我们</h2>
          <p>如您对本使用条款有任何疑问或意见，欢迎通过以下方式与我们联系：</p>
          <p>
            登竣实业（上海）有限公司<br />
            邮箱：2302137948@qq.com<br />
            地址：上海市宝山区罗泾镇银石路288号
          </p>
        </section>
      </div>
    </section>
    <div class="divider"></div>
  </div>
</template>

<script>
export default {
  name: 'TermsView',
  mounted() {
    console.log('使用条款视图已挂载');
  }
}
</script>

<style scoped>
.terms-wrapper {
  width: 100%;
  padding-top: 0;
}

#terms {
  min-height: auto;
  padding: 20px 0 60px 0; /* 与其他页面保持一致的高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

#terms > h2 {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: white;
}

.legal-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px;
  line-height: 1.7;
  font-size: 14px;
  color: #f5f5f5;
  background: #222;
  border-radius: 10px;
  text-align: left;
  width: 80%;
}

.legal-page h1 {
  font-size: 24px;
  margin-bottom: 8px;
  color: white;
}

.legal-page .updated-at {
  font-size: 13px;
  color: #999;
  margin-bottom: 20px;
}

.legal-page section {
  margin-bottom: 30px;
}

.legal-page h2 {
  font-size: 18px;
  margin-top: 24px;
  margin-bottom: 12px;
  color: white;
  border-bottom: 2px solid #e50914;
  padding-bottom: 8px;
}

.legal-page p {
  margin: 12px 0;
  line-height: 1.8;
}

.legal-page strong {
  color: #e50914;
  font-weight: 600;
}

.legal-page ul {
  padding-left: 24px;
  margin: 8px 0 16px;
}

.legal-page li {
  margin: 6px 0;
  line-height: 1.7;
}

.divider {
  width: 80%;
  max-width: 1200px;
  height: 2px;
  background: #e50914;
  margin: 0 auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .legal-page {
    width: 90%;
    padding: 24px 16px;
    font-size: 13px;
  }

  .legal-page h2 {
    font-size: 16px;
  }

  .legal-page h1 {
    font-size: 20px;
  }
}
</style>

